import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/apps/id/tools/page';

export const Route = createFileRoute('/_app/_chat/apps/$id/tools/')({
  component: Page,
});
